import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { FormDescription, FormLabel } from '@/lib/form';
import { PromoBannerTextPart } from '@repo/types/src/promo-banner';
import { Plus, Trash } from 'lucide-react';

interface Props {
  value: PromoBannerTextPart[];
  onChange: (parts: PromoBannerTextPart[]) => void;
}

export const TextPartsEditor = ({ value, onChange }: Props) => {
  const addPart = () => onChange([...value, { text: '', highlight: false }]);

  const removePart = (index: number) =>
    onChange(value.filter((_, i) => i !== index));

  const updatePart = (index: number, patch: Partial<PromoBannerTextPart>) =>
    onChange(
      value.map((part, i) => (i === index ? { ...part, ...patch } : part)),
    );

  return (
    <div className="flex flex-col gap-3">
      <FormLabel>Texte</FormLabel>
      <FormDescription>
        Aperçu :{' '}
        {value.map((part, i) =>
          part.highlight ? (
            <strong key={i}>
              {part.text}
              {i < value.length - 1 ? ' ' : ''}
            </strong>
          ) : (
            <span key={i}>
              {part.text}
              {i < value.length - 1 ? ' ' : ''}
            </span>
          ),
        )}
      </FormDescription>

      <div className="flex flex-col gap-2">
        {value.map((part, index) => (
          <div key={index} className="flex items-center gap-2">
            <Input
              type="text"
              placeholder={`Partie ${index + 1}`}
              value={part.text}
              onChange={(e) => updatePart(index, { text: e.target.value })}
              className="flex-1"
            />
            <div className="flex items-center gap-1 shrink-0">
              <Checkbox
                checked={part.highlight}
                onCheckedChange={(checked) =>
                  updatePart(index, { highlight: !!checked })
                }
              />
              <span className="text-sm text-zinc-500">En valeur</span>
            </div>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              onClick={() => removePart(index)}
              disabled={value.length === 1}
            >
              <Trash size={16} color="red" />
            </Button>
          </div>
        ))}
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={addPart}
        className="self-start"
      >
        <Plus size={16} className="mr-1" /> Ajouter une partie
      </Button>
    </div>
  );
};
